<template>
  <div class="panel-body">
    <div class="left">
      <div v-if="Object.keys(amazonLinkingInfo).length" :class="amazonLinkingInfo.classes">
        <span>{{ amazonLinkingInfo.amazonLinkingStatus }}</span> <br>
        {{ amazonLinkingInfo.subTitle }}
      </div>

      <div v-if="userInfo.hasSpAccount && userInfo.enableFlag !== false">
        <div class="mr-b-10">
          セールモンスターは、このアカウントを使用してAmazonとデータ連携を行います。<br>
        </div>
        <div class="form-group flexbox">
          <label class="control-label flex-item flex-lable flexbox justify-between seller-id-label">
            出品者ID
          </label>
          <div class="flex-item flex-input">
            <span style="display: block" v-show="errors.has('amazonMerchantId')" class="text-danger">※{{ errors.first('amazonMerchantId') }}</span>
            <input class="form-control" type="text" data-vv-name="amazonMerchantId" v-validate="'required|max:20'" v-model="data.amazonMerchantId" data-vv-as="出品者ID" :disabled="hasMerchantId">
          </div>
        </div>
      </div>
      <div class="mr-b-30 mr-t-50">
        <div class="text--underline">「Amazonと連携」ボタンについて</div>
        <p class="pd-l-10 m-b-lg">セールモンスターとご利用中のセラーセントラルアカウントを連携します。</p>
        <p class="pd-l-10 m-b-lg">
          「Amazonと連携」ボタンをクリックすると、<br>
          Amazonセラーセントラルの「セールモンスターを承認」画面に移動します。<br>
          画面に表示された内容を確認し、セールモンスターのアクセス許可を承認していただくと、連携完了です。
        </p>
        <div class="m-b">※詳しい手順は<a class="text--underline" :href="downloadUrl" download target="_blank">こちら</a></div>
      </div>
      <div class="text-center box-btn-link-amazon">
        <button class="btn btn-warning w-254 btn-link-amazon" @click="updateAmazonInfo">Amazonと連携</button>
      </div>
    </div>
  </div>
</template>
<script>
import Const from '@/common/msg'
import Util from '@/common/utility'
import SettingService from '@/services/settingservice'
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      err: null,
      data: {},
      isUpdated: false,
      oldData: {},
      disabled: true,
      loader: null,
      downloadUrl: `${process.env.NODE_DOMAIN}/static/dists/pdf/AmazonMws.pdf`,
      hasMerchantId: true
    }
  },

  created () {
    this.getAmazonInfo()
  },

  computed: {
    ...mapGetters({
      isShowModal: 'getIsShowModal',
      userInfo: 'getUser'
    }),

    amazonLinkingInfo () {
      /*
        Value expireAt
          1 => 0 ~ 31 days
          2 => > 31 days
          3 => < 0 days
          4 => null
      */
      const amazonReLinked = {
        amazonLinkingStatus: 'Amazon連携済',
        classes: 'box-amazon-linking-status amazon-linking-failure',
        subTitle: '※再設定を行ってください'
      }
      const amazonLinked = {
        amazonLinkingStatus: 'Amazon連携済',
        classes: 'box-amazon-linking-status amazon-linking-success',
        subTitle: ''
      }
      const amazonUnlinked = {
        amazonLinkingStatus: 'Amazon未連携',
        classes: 'box-amazon-linking-status amazon-linking-failure',
        subTitle: ''
      }
      const hasSpAccount = this.userInfo.hasSpAccount
      const enableFlag = this.userInfo.enableFlag
      const expireAt = this.userInfo.expireAt

      if (!hasSpAccount || !enableFlag) {
        return amazonUnlinked
      }

      let pattern = {}
      if ([1, 3, 4].includes(expireAt)) {
        pattern = amazonReLinked
      } else if (expireAt === 2) {
        pattern = amazonLinked
      }

      return pattern
    }
  },

  methods: {
    async getAmazonInfo () {
      let self = this
      SettingService.getAmazonInfo()
        .then((response) => {
          self.data = Util.transformNull(response['amazon-information'], true)
          if (self.data.amazonMerchantId) {
            self.hasMerchantId = true
          } else {
            self.hasMerchantId = false
          }
          self.oldData = {...self.data}
        })
        .catch((error) => {
          self.err = error
        })
        .finally(() => {
          if (this.$route.params.tab === 'amazon-info') {
            this.$events.fire('done')
          }
        })
    },

    async updateAmazonInfo () {
      let self = this
      let logParams = {
        name: eventCode.warehouse_amazon.amazon_info_tab.click_link_with_amazon_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let updateAmazonMsg = Const.updateSuccess
      let result = await this.$validator.validateAll()
      let _data = {}
      if (self.hasMerchantId) {
        _data.record = {
          ...self.data,
          amazonMerchantId: self.oldData.amazonMerchantId
        }
      } else {
        _data.record = self.data
      }
      if (result) {
        self.loader = this.$loading.show()
        SettingService.postAmazonInfo(_data)
          .then((response) => {
            self.isUpdated = true
            self.hasMerchantId = true
            self.oldData = {...self.data}
            window.location.href = response.data.records.data.redirect_uri
          })
          .catch((error) => {
            updateAmazonMsg = error
            // 変更項目は画面更新しない
            self.isUpdated = true
            this.$store.commit('toggleModal', {
              show: true,
              message: updateAmazonMsg
            })
          })
          .finally(() => {
            self.loader && self.loader.hide()
          })
      }
    },

    async checkDisabledButton () {
      let result = await this.$validator.validate(null, null, { silent: true })
      this.disabled = !result
    }
  },

  watch: {
    data: {
      handler () {
        setTimeout(() => this.checkDisabledButton(), 100)
      },
      deep: true
    },
    isShowModal (newVal, oldVal) {
      if (!newVal && !this.isUpdated) {
        this.data = {...this.oldData}
      }
    }
  },

  beforeDestroy () {
    this.loader && this.loader.hide()
  },

  mounted () {
    setTimeout(() => {
      let amazonLinkingStatus = this.$route.query.status || ''
      if (amazonLinkingStatus === 'success') {
        this.$store.commit('toggleModal', {
          show: true,
          message: 'Amazonと連携しました'
        })
      } else if (amazonLinkingStatus === 'failure') {
        this.$store.commit('toggleModal', {
          show: true,
          message: 'Amazonと連携できませんでした'
        })
      }
    }, 3000)

    if (this.currentTab && this.currentTab === 'amazon-info') {
      let logParams = {
        name: eventCode.warehouse_amazon.amazon_info_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>

<style scoped>
.box-amazon-linking-status {
  width: 50%;
  padding: 12px 0;
  text-align: center;
  margin: 0 auto 30px;
  border: 2px solid #e4e5e7;
}
.box-amazon-linking-status span {
  font-weight: bold;
  font-size: 20px;
}
.amazon-linking-success {
  border: 2px solid #70ad47;
  background-color: #d6e9c6;
  color: #70ad47;
}
.amazon-linking-failure {
  border: 2px solid #f5c6cb;
  background-color: #f8d7da;
  color: #721c24;
}
.seller-id-label {
  min-width: 200px;
  max-width: 200px;
}
.box-btn-link-amazon {
  margin-top: 50px;
}
.btn-link-amazon {
  font-size: 24px;
  padding: 10px 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAmazon/AmazonInfo.vue